module.exports = __webpack_public_path__ + "assets/923ff2c25d43f7e18a0d1427cf33844c1.jpg";